import React, { Component } from 'react';
import './CompanyIdentificationModal.css';

/**
 * CompanyIdentificationModal
 * ─────────────────────────────────────────────────────
 * CHANGES:
 *  1. Cleaned up formatting
 *  2. Added autoComplete="off" on input to prevent browser autofill conflicts
 *  3. No functional changes — component was already clean
 */

class CompanyIdentificationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyCode: '',
      isValidating: false,
      error: null,
    };
  }

  handleInputChange = (e) => {
    this.setState({ companyCode: e.target.value, error: null });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const { companyCode } = this.state;

    if (!companyCode.trim()) {
      this.setState({ error: 'Please enter your company code' });
      return;
    }

    this.setState({ isValidating: true, error: null });

    try {
      await this.props.onValidate('code', companyCode);
    } catch (error) {
      this.setState({
        error: error.message || 'Invalid company code. Please try again.',
        isValidating: false,
      });
    }
  };

  handleRootLogin = (e) => {
    e.preventDefault();

    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = window.location.port ? `:${window.location.port}` : '';

    const parts = hostname.split('.');
    const mainDomain = parts.length >= 2 ? parts.slice(-2).join('.') : hostname;

    window.location.href = `${protocol}//admin.${mainDomain}${port}/login`;
  };

  render() {
    const { isOpen, onClose } = this.props;
    const { companyCode, isValidating, error } = this.state;

    if (!isOpen) return null;

    return (
      <div className="company-modal-overlay" onClick={onClose}>
        <div className="company-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="company-modal-header">
            <h2>Sign In to Your Company</h2>
            <button className="company-modal-close" onClick={onClose}>
              &times;
            </button>
          </div>

          <div className="company-modal-body">
            <p className="company-modal-description">
              Enter your company code to continue to login
            </p>

            <form onSubmit={this.handleSubmit} className="identification-form">
              <div className="form-group">
                <label htmlFor="companyCodeInput">Company Code</label>
                <input
                  id="companyCodeInput"
                  type="text"
                  className={`form-control ${error ? 'is-invalid' : ''}`}
                  placeholder="e.g., ACME123"
                  value={companyCode}
                  onChange={this.handleInputChange}
                  disabled={isValidating}
                  autoFocus
                  autoComplete="off"
                />
                {error && <div className="error-message">{error}</div>}
                <small className="form-text">
                  Your company code was provided during onboarding
                </small>
              </div>

              <button
                type="submit"
                className="btn-submit"
                disabled={isValidating || !companyCode.trim()}
              >
                {isValidating ? (
                  <>
                    <span className="spinner" /> Validating&hellip;
                  </>
                ) : (
                  'Continue to Login'
                )}
              </button>
            </form>

            <div className="root-login-section">
              <a
                href="#root-login"
                className="root-login-link"
                onClick={this.handleRootLogin}
              >
                <i className="fa fa-user-shield" /> Root User Login
              </a>
              <small className="root-login-hint">(Management Company Login)</small>
            </div>

            <div className="company-modal-footer">
              <p>If you do not know your company code, contact your administrator.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CompanyIdentificationModal;
